import { closeDialog, updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfLoginTooManySessionModal } from './TooManySessionsModalConstants';

export function openLoginTooManySessionsModal() {
  return (dispatch) => {
    dispatch(updateDialog({
      id: typeOfLoginTooManySessionModal,
      dialogType: typeOfLoginTooManySessionModal,
    }));
  };
}

export function closeLoginTooManySessionsModal() {
  return (dispatch) => {
    dispatch(closeDialog({
      id: typeOfLoginTooManySessionModal,
    }));
  };
}
